export default "__VITE_ASSET__BvShqjgF__"